module.exports = __webpack_public_path__ + "static/media/parallelogram.f47ccbb8.svg";